import { globalStyObj } from '@/assets/packageAssets/allStyleConfigs/a-global-cfg.js'

import { echoStyObj } from '@/assets/packageAssets/allStyleConfigs/echo.cfg.js'
import { joychatStyObj } from '@/assets/packageAssets/allStyleConfigs/joychat.cfg.js'
import { kikoStyObj } from '@/assets/packageAssets/allStyleConfigs/kiko.cfg.js'
import { vavaStyObj } from '@/assets/packageAssets/allStyleConfigs/vava.cfg.js'
import { vibeoStyObj } from '@/assets/packageAssets/allStyleConfigs/vibeo.cfg.js'

// 包变量
const styObj = {
  echo: {
    // 样式资源
    ...echoStyObj,
    // 图片资源
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`,
  },
  joychat: {
    // 样式资源
    ...joychatStyObj,
    // 图片资源
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`,
  },
  kiko: {
    // 样式资源
    ...kikoStyObj,
    // 图片资源
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`,
  },
  vava: {
    // 样式资源
    ...vavaStyObj,
    // 图片资源
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`,
  },
  vibeo: {
    // 样式资源
    ...vibeoStyObj,
    // 图片资源
    '--icon-bg1': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg1.png')})`,
    '--icon-bg2': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg2.png')})`,
    '--icon-bg3': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg3.png')})`,
    '--icon-bg5': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg5.png')})`,
    '--icon-bg6': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg6.png')})`,
    '--icon-bg7': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg7.png')})`,
    '--icon-bg8': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg8.png')})`,
    '--icon-bg9': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/bg9.png')})`,
    '--icon-got': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/got.png')})`,
    '--icon-time': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/time.png')})`,
    '--icon-switchoff': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-off.png')})`,
    '--icon-switchon': `url(${require('@/assets/packageAssets/views/P1_Boys/SignIn/default/switch-on.png')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars () {
      if (this.packageName && styObj[this.packageName]) {
        // 全局 + 局部包
        return { ...globalStyObj, ...styObj[this.packageName] }
      }
      return {}
    }
  }
}
